import { ATTEMPT_STATUSES } from "@miplatform/constants";
import { getInitials } from "@miplatform/utils";

export const getWorkLocationMarker = (color, status, selected) => {
  if (selected) {
    return `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path fill="#2196F3" d="M24 6c-8.837 0-16 7.163-16 16s16 28 16 28s16-21.163 16-28s-7.163-16-16-16zm0 96c-3.314 0-6-2.686-6-6s2.686-6 6-6s6 2.686 6 6s-2.686 6-6 6z"/>
        <circle cx="24" cy="23" r="12" fill="#2196F3" />
      </svg>`
    )}`;
  }
  if (
    [ATTEMPT_STATUSES.PLANNED, ATTEMPT_STATUSES.DISPATCHED].includes(status)
  ) {
    return `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path fill="white" d="M24 6c-8.837 0-16 7.163-16 16s16 28 16 28s16-21.163 16-28s-7.163-16-16-16zm0 96c-3.314 0-6-2.686-6-6s2.686-6 6-6s6 2.686 6 6s-2.686 6-6 6z"/>
        <circle cx="24" cy="23" r="12" fill="${color}"/>
      </svg>`
    )}`;
  }
  if (status === ATTEMPT_STATUSES.STARTED) {
    return `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path fill="#FFF176" d="M24 6c-8.837 0-16 7.163-16 16s16 28 16 28s16-21.163 16-28s-7.163-16-16-16zm0 96c-3.314 0-6-2.686-6-6s2.686-6 6-6s6 2.686 6 6s-2.686 6-6 6z"/>
        <circle cx="24" cy="23" r="12" fill="${color}" />
      </svg>`
    )}`;
  }
  if (
    [
      ATTEMPT_STATUSES.SUBMITTED,
      ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS,
      ATTEMPT_STATUSES.CLOSED,
    ].includes(status)
  ) {
    return `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path fill="#4CAF50" d="M24 6c-8.837 0-16 7.163-16 16s16 28 16 28s16-21.163 16-28s-7.163-16-16-16zm0 96c-3.314 0-6-2.686-6-6s2.686-6 6-6s6 2.686 6 6s-2.686 6-6 6z"/>
        <circle cx="24" cy="23" r="12" fill="${color}"  />
      </svg>`
    )}`;
  }

  return null;
};

export const getResourceLocationMarker = (name) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" style="filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));">
        <path d="M27.9102 37.7606L23.0325 46.0623L18.0574 37.8186L27.9102 37.7606Z" fill="white" stroke="white"/>
        <rect x="3" width="40" height="40" rx="19" fill="white"/>
        <rect x="5" y="2" width="36" height="36" rx="18" fill="#0D47A1"/>
        <text x="50%" y="52%" text-anchor="middle" fill="white" font-size="16" font-family="Arial">${getInitials(
          name
        )}</text>
    </svg>`
  )}`;
